export default __webpack_public_path__ + "static/media/antiestres.baec5a92.png";